import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'
import _imports_1 from '../../assets/Images/logo2.png'


const _hoisted_1 = { class: "content-dashboard" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"content-dashboard__section-header\"><div class=\"content-dashboard__section-header__logo1\"><img src=\"" + _imports_0 + "\" alt=\"\"><span>Admin</span></div><div class=\"content-dashboard__section-header__logo2\"><img src=\"" + _imports_1 + "\" alt=\"\"></div></div><div class=\"content-dashboard__section-video\"><div class=\"content-dashboard__section-video__info-video\"><i class=\"far fa-question-circle\"></i><span>Video tutorial for the use of the system</span><button type=\"button\" class=\"btn btn-primary\">WATCH VIDEO</button></div></div><hr>", 3)
const _hoisted_5 = { class: "reportes mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "CONTACT FORMS")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "reports__section1 tw-justify-center" }
const _hoisted_9 = { class: "reports__section1__options" }
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " ACTOR TYPE ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  selected: ""
}, "Choose...", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "reports__section1__options" }
const _hoisted_15 = { class: "input-group mb-3" }
const _hoisted_16 = { class: "reports__button d-flex justify-content-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "reports__data mt-3 pb-3 position-relative" }
const _hoisted_19 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_20 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ROLE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MESSAGE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATED AT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "RESPOND"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DELETE")
  ])
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt tw-text-[RED] tw-text-[18px]" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_33 = { class: "modal-dialog" }
const _hoisted_34 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_36 = { class: "modal-body" }
const _hoisted_37 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_39 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_41 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_42 = { class: "tw-flex tw-justify-end tw-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("select", {
              class: "custom-select",
              id: "select01",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.usertype) = $event))
            }, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: role.idRole
                }, _toDisplayString(role.name), 9, _hoisted_13))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.params.usertype]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_datepicker, {
              "auto-apply": "",
              class: "tw-w-full",
              range: "",
              format: _ctx.formatDate,
              "text-input": _ctx.configDatePicker,
              modelValue: _ctx.configDatePicker.date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
              placeholder: "Enter date range..."
            }, null, 8, ["format", "text-input", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getContactForms()))
        }, "GENERATE")
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_loading, {
          active: _ctx.loaderConfig.isLoading,
          "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
          "can-cancel": false,
          loader: 'dots',
          "is-full-page": !_ctx.loaderConfig.fullPage
        }, null, 8, ["active", "is-full-page"]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _hoisted_21,
            (_ctx.listContacts && _ctx.listContacts.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listContacts, (contact) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(contact.firstname + " " + contact.lastname), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.phone), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.email), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.role), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.message), 1),
                      _createElementVNode("td", null, _toDisplayString(contact.createdOn), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#exampleModalMessage",
                          href: "#",
                          onClick: ($event: any) => (_ctx.selectedContact = contact)
                        }, _hoisted_25, 8, _hoisted_23)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: ($event: any) => (_ctx.deleteContactForm(contact.id_contact_form))
                        }, _hoisted_28, 8, _hoisted_26)
                      ])
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            (_ctx.listContacts && _ctx.listContacts.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, _hoisted_31))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "tw-w-full tw-h-[32px]",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mail.subject) = $event)),
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.mail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mail.message) = $event)),
                  cols: "53",
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.mail.message]
                ])
              ])
            ]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendMail()))
                }, "SEND MESSAGE")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}